import React from "react";
import { View, Platform } from "react-native";
import { styles, ids } from "./Trustpilot.styles";
import { theme } from "../../theme";
import { Panel } from "../../Core/Panel/Panel";
import { Text } from "../../Core/Text/Text";
import { Icon } from "../../Core/Icon/Icon";
const wasteCarriersLicence = "CBDU61392";
const formatReviews = (reviews) => String(reviews).replace(/(.)(?=(\d{3})+$)/g, "$1,");
const TrustpilotSegment = ({ reviews, score, color, }) => {
    const colorHex = theme.colors[color].base;
    return (React.createElement(View, { style: styles.segmentContainer, dataSet: { media: ids.segmentContainer } },
        React.createElement(View, { style: styles.header },
            React.createElement(View, { style: styles.logo },
                React.createElement(Icon.TrustpilotLogo, { color: color, width: 124, height: 31 })),
            React.createElement(View, null,
                React.createElement(Icon.TrustpilotStars, { width: 110, height: 35 }))),
        React.createElement(View, { style: styles.fontSize },
            React.createElement(Text, { style: [styles.fontSize, { color: colorHex }], dataSet: { media: ids.fontSize } },
                React.createElement(Text, { style: styles.fontBold }, score),
                " out of 5 based on",
                " ",
                React.createElement(Text, { style: styles.fontBold }, formatReviews(reviews)),
                " reviews")),
        React.createElement(View, null,
            React.createElement(Text, { style: [
                    styles.fontSize,
                    styles.fontSemibold,
                    styles.footer,
                    { color: colorHex },
                ] },
                "Waste carrier\u2019s licence:",
                " ",
                React.createElement(Text, { style: styles.fontNormal }, wasteCarriersLicence)))));
};
const TrustpilotBanner = ({ reviews, score, color, }) => {
    const colorHex = theme.colors[color].base;
    const reverseColor = color === "dark" ? "light" : "dark";
    return (React.createElement(Panel, { color: reverseColor, styles: styles.panel },
        React.createElement(View, { style: styles.bannerContainer },
            Platform.OS === "web" && (React.createElement(View, { style: styles.leftCircle },
                React.createElement(Icon.TrustpilotCircle, { width: 22, height: 22 }))),
            React.createElement(Text, { style: [styles.fontSize, { color: colorHex }] },
                "TrustScore ",
                React.createElement(Text, { style: styles.fontBold }, score),
                " ",
                React.createElement(Text, { style: styles.separator }, "|"),
                " ",
                React.createElement(Text, { style: styles.fontBold },
                    formatReviews(reviews),
                    " Reviews")),
            React.createElement(View, null,
                React.createElement(Icon.TrustpilotStars, { width: 123, height: 23 })),
            React.createElement(Text, { style: [styles.fontSize, { color: colorHex }] }, "Trustpilot"),
            Platform.OS === "web" && (React.createElement(View, { style: styles.rightCircle },
                React.createElement(Icon.TrustpilotCircle, { width: 22, height: 22 }))))));
};
export const Trustpilot = ({ variant = "segment", color = "dark", ...rest }) => {
    const props = { ...rest, color };
    if (variant === "segment") {
        return React.createElement(TrustpilotSegment, { ...props });
    }
    return React.createElement(TrustpilotBanner, { ...props });
};
//# sourceMappingURL=Trustpilot.js.map